module.exports = __webpack_public_path__ + "static/media/img5.c2b6739a.jpg";